@if (additionalInfo) {
  <div class="additional-info">
    {{ additionalInfo }}
  </div>
}
@if (beInfos) {
  <div class="additional-info">
    {{ beInfos }}
  </div>
}
@if (uiInfos) {
  <div class="additional-info">
    {{ uiInfos }}
  </div>
}
